/* istanbul ignore file */
import { useContext } from 'react';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import UserContext from '@context/User/user-context';

export const MyBoardsQuery = gql`
  query myBoards {
    myBoards {
      customerPrimaryImage
      exploreBoardItemCount
      exploreBoardItems(limit: 9) {
        imageUrl
      }
      id
      name
      created
    }
  }
`;

export default function useMyBoards() {
  const { user } = useContext(UserContext);
  const {
    data, loading, error, refetch, networkStatus,
  } = useQuery(MyBoardsQuery, {
    skip: !user,
  });

  return {
    myBoards: (data && data.myBoards) || [],
    loading,
    error,
    refetch,
    networkStatus,
  };
}
